import { useEffect } from "react";

/**
 * MatomoTracker is a component that tracks page views and enables link tracking.
 * It uses the Matomo JavaScript library to track user interactions.
 *
 * @param {Object} props - The component props.
 * @param {string} props.siteId - The Matomo site ID.
 * @param {string} props.matomoUrl - The Matomo URL.
 */
const MatomoTracker = ({ siteId, matomoUrl }) => {
	useEffect(() => {
		if (!siteId || !matomoUrl) return;
		console.log({ matomoUrl, siteId });

		const script = document.createElement("script");
		script.type = "text/javascript";
		script.async = true;
		script.defer = true;
		script.src = `${matomoUrl}/matomo.js`;
		document.head.appendChild(script);
		console.log("script", script);

		window._paq = window._paq || [];
		window._paq.push(["trackPageView"]);
		window._paq.push(["enableLinkTracking"]);
		window._paq.push(["setTrackerUrl", `${matomoUrl}/matomo.php`]);
		window._paq.push(["setSiteId", siteId]);
	}, [siteId, matomoUrl]);

	return null;
};

export default MatomoTracker;
